// Refresh a screen every `ms` while its browser tab is visible (Task 10): a hidden tab asks the API nothing, and
// coming back to it refreshes at once. Loads once on start even if the tab opened in the background.
//   usePoll(load, ms, enabled = true, key)   key: restart (and load at once) when it changes, like an effect's deps.
import { useEffect, useRef } from "react";

export function usePoll(load, ms, enabled = true, key) {
  const latest = useRef(load);
  latest.current = load;   // the timer always calls the newest load, with the screen's current state
  useEffect(() => {
    if (!enabled) return;
    let timer = null;
    const start = () => { if (!timer) timer = setInterval(() => latest.current(), ms); };
    const stop = () => { clearInterval(timer); timer = null; };
    const onVisibility = () => {
      if (document.visibilityState === "visible") { latest.current(); start(); } else stop();
    };
    latest.current();
    if (document.visibilityState === "visible") start();
    document.addEventListener("visibilitychange", onVisibility);
    return () => { stop(); document.removeEventListener("visibilitychange", onVisibility); };
  }, [ms, enabled, key]);
}
